import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

// Bold White/Orange Design (Main Site)
import NavbarAlt from "./components/NavbarAlt";
import FooterAlt from "./components/FooterAlt";
import HomeAlt from "./pages/HomeAlt";
import PortfolioAlt from "./pages/PortfolioAlt";
import ServicesAlt from "./pages/ServicesAlt";
import AboutAlt from "./pages/AboutAlt";
import ContactAlt from "./pages/ContactAlt";

// Admin Panel
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProjects from "./pages/admin/AdminProjects";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminServices from "./pages/admin/AdminServices";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main Site - Bold White/Orange Design */}
          <Route path="/" element={<><NavbarAlt /><HomeAlt /><FooterAlt /></>} />
          <Route path="/portfolio" element={<><NavbarAlt /><PortfolioAlt /><FooterAlt /></>} />
          <Route path="/portfolio/:id" element={<Navigate to="/portfolio" replace />} />
          <Route path="/services" element={<><NavbarAlt /><ServicesAlt /><FooterAlt /></>} />
          <Route path="/about" element={<><NavbarAlt /><AboutAlt /><FooterAlt /></>} />
          <Route path="/contact" element={<><NavbarAlt /><ContactAlt /><FooterAlt /></>} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="projects" element={<AdminProjects />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="services" element={<AdminServices />} />
          </Route>

          {/* Redirect old /alt routes to main site */}
          <Route path="/alt" element={<Navigate to="/" replace />} />
          <Route path="/alt/*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
